import React from 'react';
import { Grid2 } from '@mui/material';

const UnAuthorized: React.FC<{}> = () => {
  return (
    <Grid2 container alignItems="center" direction="column" mt={10}>
      <h1>401 Unauthorized</h1>
      <span>You do not have permission to view this page.</span>
      <a href="/dashboard">Go Back Home</a>
    </Grid2>
  );
};

export default UnAuthorized;
